import { push } from "@socialgouv/matomo-next";

export const useAnalytics = () => {
  return {
    track: (
      category: string,
      action: string,
      name?: string,
      value?: number,
    ) => {
      if (name && !value) {
        value = 1;
      }
      push(["trackEvent", category, action, name, value]);
    },
  };
};
